// @ts-nocheck



import React, { useEffect, useState } from 'react';

import TreeSelect from '../ui/TreeSelect';
import { expenseDirectionApi } from '../../lib/api';

import notification from 'antd/lib/notification';



export default (props) => {
  const [data, setData] = useState([]);
  const [value] = useState();

  const fetchData = async () => {
    try {
      const data = await expenseDirectionApi.fetchExpenseDirection({
        pageSize: 10000
      });

      const buildTree = (data) => {
        return data.reduce((result, expense) => {
          let index = result.findIndex(
            (el) => el.key === expense.budgetLineItemName
          );

          if (index === -1) {
            index =
            result.push({
              key: expense.budgetLineItemName,
              value: expense.budgetLineItemId,
              title: expense.budgetLineItemName,
              selectable: false,
              children: []
            }) - 1;
          }
          result[index].children.push({
            key: expense.id,
            value: expense.id,
            title: expense.name,
            isLeaf: true
          });
          return result;
        }, []);
      };

      setData(buildTree(data.data));
    } catch (error) {
      console.error(error);
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <TreeSelect
      value={value}
      placeholder="Выберите направление расходов"
      treeData={data}
      treeNodeFilterProp="title"
      showSearch
      allowClear
      {...props} />);


};
